import checkmark from './checkmark.svg'

const sizes = {
  l: 'large',
  m: 'medium',
  i: 'icon',
  e: 'error',
}
const textSizes = {
  [sizes.l]: 'size-ml',
  [sizes.i]: 'size-ml',
  [sizes.m]: 'size-m',
  [sizes.e]: 'size-m',
}
const tones = {
  p: 'plain',
  h: 'highlight',
  l: 'lowlight',
  e: 'error',
}

const classesFor = ({size, tone, selected}) => {
  const buttonClass = size === sizes.i ? '' : 'brand'
  const textClass = Object.values(sizes).includes(size) ? size : sizes.e
  const textSizeClass = textSizes[textClass]

  const toneClass = Object.values(tones).includes(tone) ? tone : tones.e

  const selectedClass = selected ? 'selected' : ''

  return [buttonClass, textClass, textSizeClass, toneClass, selectedClass].join(' ')
}

export const Button = ({
  children,
  size = sizes.m,
  tone = tones.p,
  selected = false,
  action,
}) => (
  <button className={classesFor({size, tone, selected})} onClick={action}>
    {children}
    {selected ? <Checkmark /> : null}
  </button>
)

const Checkmark = () => (
  <div className="float-cover">
    <img className="button-icon" src={checkmark} alt="Checkmark" />
  </div>
)
